import { ButtonProps } from '@chakra-ui/react';
import React from 'react';

import { ButtonUI } from './button.styled';

export enum ButtonVariants {
    primary = 'primary',
    secondary = 'secondary',
    iconPrimary = 'iconPrimary',
    feedback = 'feedback',
    needHelp = 'needHelp',
    outline = 'outline'
}

export const Button = ({
    children,
    variant = ButtonVariants.primary,
    ...restProps
}: ButtonProps) => {
    return (
        <ButtonUI
            data-testid={'button-component'}
            {...restProps}
            variant={variant}
        >
            {children}
        </ButtonUI>
    );
};
